import RiskProfileDetailView from './RiskProfileDetailView';
import RiskProfileListView from './RiskProfileListView';

const views = {
  RiskProfileDetailView,
  RiskProfileListView,
};
export default views;
